<template>
    <section>
        <form @submit.prevent="confirm">
            <h2 class="title pink">Claim Privacy</h2>
            <hr/>
            <div class="row">
                <div class="col">
                    <p>
                    Dear {{ fullName }},<br/>
                    in order to better manage your claim, we ask you to give your consent to the processing of special categories of your personal data 
                    that will remain valid for your future claims and you can modify it by accessing your user profile.
                    </p> 
                </div>
            </div>
            <hr/>
            <div class="form-group">
                <b-form-checkbox
                    id="privacy_2"
                    v-model="form.privacy_2"
                    name="privacy_2"
                    value="accepted"
                    unchecked-value="not_accepted"
                    :class="{ 'is-invalid': $v.form.privacy_2.$error }"
                    :state="validateState('privacy_2')"
                    >
                    I declare to have duly read and understood the information relating to the processing of personal data provided by {{ this.$strings.us }}. 
                    (downloadable <download what="privacy_2"/>), and I consent to the processing of special categories of personal data for the purpose of data processing.                    
                </b-form-checkbox>
                <div class="invalid-feedback" v-if="!$v.form.privacy_2.required">* you need to accept to continue</div>
            </div>
            <hr />
            <div class="form-group">
                <b-form-checkbox
                    id="privacy_axa_2"
                    v-model="form.privacy_axa_2"
                    name="privacy_axa_2"
                    value="accepted"
                    unchecked-value="not_accepted"
                    :class="{ 'is-invalid': $v.form.privacy_axa_2.$error }"
                    :state="validateState('privacy_axa_2')"
                    >
                    I declare to have duly read the information required by the European Regulation 2016/679 on the protection of personal data provided by 
                    {{ this.$strings.partner }} (downloadable <download what="privacy_axa_2"/>), to have taken note of its contents, and agree 
                    to the processing of my data, including special categories of personal data, for insurance purposes relating to the specific contractual 
                    relationship between the Insured and the Insurance Company according to the methods specified in the downloadable files
                </b-form-checkbox>
                <div class="invalid-feedback" v-if="!$v.form.privacy_axa_2.required">* you need to accept to continue</div>
            </div>
            <hr />
            <div class="row-btn">
                <button type="submit" class="btn btn-primary">Next</button>
            </div>											
        </form>
    </section>                
</template>

<script>
//import { required } from 'vuelidate/lib/validators'

export default {
    data: function () {
        return {
            form: {
                privacy_2: (this.$store.state.privacy != null) ? this.$store.state.privacy.privacy_2 : "not_accepted",
                privacy_axa_2: (this.$store.state.privacy != null) ? this.$store.state.privacy.privacy_axa_2 : "not_accepted",
            }            
        }
    },
    validations: {
        form: {
            privacy_2: {
                checked: value => value == 'accepted',
            },
            privacy_axa_2: {
                checked: value => value == 'accepted',
            },
        }
    },
    /*created() {
        this.$emit('set-style', '');
        this.$emit('set-small-logo');
    },*/ 
    computed: {
        fullName(){
            return this.$store.state.userInfo.name
        }
    },
    methods: {
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty && $error==true ? !$error : null;
        },
        confirm: function(){

            this.$v.$touch()
            if (this.$v.$invalid) {
                return false;
            }

            this.$store.dispatch('acceptPrivacy', this.form)
                .then(() => {
                    this.$router.push('/file-claim');
                })
                .catch(() => {
                    //console.log(err);
                });
        }
    }
}
</script>